export enum Key {
  LEARNING_SETS_CACHE_STATE = "LEARNING_SETS_CACHE_STATE",
  TOKEN = "TOKEN",
  VERSION = "VERSION",
  LOCAL_HISTORY = "local-history",
  CLIENT = "client",
  CACHED_MODULES = "CACHED_MODULES",
  /** String list of flags activated using the dev tools */
  DEV_FLAGS = "dev-flags",
  /** A AICurriculumFinishedEvent stored when the TAI is finished while exploring results */
  TEST_FINISHED_EVENT = "test-finished-event",
  /** used to keep the state of the player header panel when the player rerenders */
  PLAYER_HEADER_PANEL_OPEN = "player-header-panel-open",
  /** index of the highlighted objective in the player header panel */
  PLAYER_HEADER_HIGHLIGHTED_OBJECTIVE = "player-header-highlighted-objective",
  HIDE_DUO_TUTORIAL = "hide-duo-tutorial",
  GOOGLE_CLASSROOM = "google-classroom",
  GOGGLE_ADDON_TOKEN = "goggle-addon-token",
  GOOGLE_REDIRECT_URL = "google-redirect-url",
  LOGOUT_REDIRECT_URL = "logout-redirect-url",
  IDLE_TIMEOUT = "dev-idle-timeout",
}

export const setItem = (key: Key, item: any): void => {
  const oldValue = localStorage.getItem(key);
  const newValue = JSON.stringify(item);
  localStorage.setItem(key, newValue);

  // Send storage event to be picked up by Sentry in particular
  const e = new StorageEvent("storage", {
    storageArea: window.localStorage,
    key,
    oldValue,
    newValue,
    url: window.location.href,
  });
  window.dispatchEvent(e);
};

/**
 * Reads a value stored by {@link setItem} (JSON), with a fallback for
 * values that are raw (not JSON-encoded):
 * - valid JSON -> the parsed value, assumed to be a `T`;
 * - invalid JSON -> the raw string, which is only a correct `T` when `T` is
 *   `string` (`T` is erased at runtime, so it cannot be checked — callers
 *   reading non-string types from a corrupted key get the raw string);
 * - missing key (or raw empty string) -> `undefined`.
 */
export function getItem<T = string>(key: Key): T | undefined {
  const rawItem = localStorage.getItem(key);
  if (!rawItem) return undefined;
  try {
    return JSON.parse(rawItem) as T;
  } catch {
    return rawItem as unknown as T;
  }
}

export const removeItem = (key: Key): void => {
  localStorage.removeItem(key);
};

export const clear = (): void => {
  localStorage.clear();
};
